import { useState } from "react";
import Logo from "@/components/sections/header/Logo";
import DesktopNav from "@/components/sections/header/DesktopNav";
import HeaderActions from "@/components/sections/header/HeaderActions";
import MobileMenu from "@/components/sections/header/MobileMenu";

export default function Header({ t, lang, setLang, scrollTo }) {
  const [menuOpen, setMenuOpen] = useState(false);

  const handleScrollTo = (id) => {
    setMenuOpen(false);
    scrollTo(id);
  };

  return (
    <header className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-white/80 border-b border-[var(--border)]/60">
      <div className="max-w-7xl mx-auto px-6 sm:px-10 h-16 sm:h-20 flex items-center justify-between gap-3">
        <Logo onClick={() => handleScrollTo("hero")} />
        <DesktopNav t={t} scrollTo={handleScrollTo} />
        <HeaderActions
          t={t}
          lang={lang}
          setLang={setLang}
          onBook={() => handleScrollTo("booking")}
          menuOpen={menuOpen}
          toggleMenu={() => setMenuOpen(!menuOpen)}
        />
      </div>

      {menuOpen && (
        <MobileMenu t={t} lang={lang} setLang={setLang} scrollTo={handleScrollTo} />
      )}
    </header>
  );
}
